"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOneDistributorCustomFilters = void 0;
const routes_1 = require("../../routes");
const getOneDistributorCustomFilters = (client) => async (distributorId, categoryId, cropId) => {
    const url = routes_1.ENDPOINTS.GET_PARTNER_CUSTOM_CONFIG.applyParams(distributorId, 'filters');
    const { data } = await client.get(url, {
        params: {
            categoryId,
            cropId,
        },
    });
    if (data && data.length > 0) {
        return data[0];
    }
    return null;
};
exports.getOneDistributorCustomFilters = getOneDistributorCustomFilters;
